import type { Prototype } from "../prototype-types";

export const brandonDangPrototypes: Prototype[] = [
  {
    id: "bd-checkout-order-notes",
    name: "Checkout Order Notes",
    path: "/bd/checkout-order-notes",
    description:
      "Collapsed, expandable per-brand order note input in the checkout cart card",
    owner: "Brandon Dang",
    createdAt: "2026-08-24",
    lastUpdated: "2026-08-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/c2e2de6c08c1793eae495a3f68d8ad281e2de1c33e58eda677aefc5dc05416a5.png",
    creationTool: "claude-code",
  },
  {
    id: "bd-brand-order-notes",
    name: "Brand Order Notes",
    path: "/bd/brand-order-notes",
    description:
      "How a retailer's checkout note appears on the brand portal order page",
    owner: "Brandon Dang",
    createdAt: "2026-09-15",
    lastUpdated: "2026-09-15",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/91a284110ba7cdb58de6dac46df3d3ff6a0ecf07e783737840077eedd595eba3.png",
    creationTool: "claude-code",
  },
  {
    id: "bd-unified-order-notes",
    name: "Unified Order Notes",
    path: "/bd/unified-order-notes",
    description:
      "Alternate design: the retailer's checkout note lives inside the existing Notes card",
    owner: "Brandon Dang",
    createdAt: "2026-09-16",
    lastUpdated: "2026-09-16",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/bb19d662af0bae85c49544414a8ac87bd4947c14de207f8100c10b6c88e1e929.png",
    creationTool: "claude-code",
  },
  {
    id: "bd-brand-promo-orders",
    name: "Brand Promo Orders",
    path: "/bd/brand-promo-orders",
    description:
      "Live replica of the brand portal Orders page with a few brand promo orders, showing every promo touchpoint that exists today",
    owner: "Brandon Dang",
    createdAt: "2026-09-24",
    lastUpdated: "2026-09-24",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/bd-brand-promo-orders.png",
    creationTool: "claude-code",
  },
  {
    id: "bd-brand-promo-orders-promo-under-total",
    name: "Brand Promo Orders: Promo Under Total",
    path: "/bd/brand-promo-orders-promo-under-total",
    description:
      "Brand Promo Orders with the promo name and sale tag under each order's total instead of next to the order number",
    owner: "Brandon Dang",
    createdAt: "2026-10-05",
    lastUpdated: "2026-10-05",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/bd-brand-promo-orders-promo-under-total.png",
    creationTool: "claude-code",
  },
  {
    id: "bd-brand-order-details",
    name: "Brand Order Details",
    path: "/bd/brand-order-details",
    description:
      "Current brand portal order details page for 12 promo setups (one page each), from New through Fulfilled, plus a sale tag tooltip mock for product and collection promos and an orders table mock where orders with several promos show “2 promotions”, and the new order email for an order with product and shop-wide promos, with the product promo shown as its name or as an icon, and the Payouts page’s payout details modal for 16 promo setups",
    owner: "Brandon Dang",
    createdAt: "2026-10-07",
    lastUpdated: "2026-10-14",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/bd-brand-order-details.png",
    creationTool: "claude-code",
  },
];
